/**
 *    Mam - Favorite
 */

(function ($) {
  // do not overwrite the namespace, if it already exists
  $.visitBerlinFavorites = $.visitBerlinFavorites || {};

  /**
   * read user token from html attribute injected by FavHelperBlock
   */
  $.visitBerlinFavorites.USER_TOKEN = $('span[data-favorites-token]').data('favorites-token');

  /**
   * add a favorite
   *
   * @param {Object} options with properties "nid" and "type"
   */
  $.visitBerlinFavorites.addFavorite = function (options) {
    $.post(
      $.visitBerlinFavorites._buildUrl('favorites/js/add'),
      { nid: options.nid, type: options.type },
      (data) => {
        if (typeof options.success === 'function') options.success(data);
      },
    );
  };

  /**
   * find out if a favorite exists
   *
   * @param {Object} options with properties "nid"
   */
  $.visitBerlinFavorites.favoriteExists = function (options) {
    $.post(
      $.visitBerlinFavorites._buildUrl('favorites/js/exists'),
      { nid: options.nid },
      (data) => {
        if (typeof options.success === 'function') options.success(data);
      },
    );
  };

  /**
   * delete a favorite by user and favorite id
   *
   * @param {Object} options
   */
  $.visitBerlinFavorites.removeFavorite = function (options) {
    $.getJSON(
      $.visitBerlinFavorites._buildUrl(`favorites/remove/${options.fid}`),
      (data) => {
        if (typeof options.success === 'function') options.success(data);
      },
    );
  };

  /**
   * delete a asset from mam by user
   *
   * @param {Object} options
   */
  $.visitBerlinFavorites.removeMamFavorite = function (options) {
    $.getJSON(
      $.visitBerlinFavorites._buildUrl(`mam/selection/remove/${options.fid}`),
      (data) => {
        if (typeof options.success === 'function') {
          options.success(data);
        }
      },
    );
  };

  /**
   * delete all favorites by user and type
   *
   * @param {Object} options with property "type"
   */
  $.visitBerlinFavorites.removeAllFavorites = function (options) {
    $.getJSON(
      $.visitBerlinFavorites._buildUrl('favorites/js/remove_all'),
      { type: options.type },
      (data) => {
        if (typeof options.success === 'function') options.success(data);
      },
    );
  };

  /**
   * count all favorites by user
   *
   * @param {Object} options
   */
  $.visitBerlinFavorites.getCount = function (options) {
    $.getJSON(
      $.visitBerlinFavorites._buildUrl('favorites/js/count'),
      (data) => {
        if (typeof options.success === 'function') options.success(data);
      },
    );
  };

  /**
     * count all favorites by user
     *
     * @param {Object} options
     */
  $.visitBerlinFavorites.getCount = function (options) {
    $.getJSON(
      $.visitBerlinFavorites._buildUrl('favorites/js/count'),
      (data) => {
        if (typeof options.success === 'function') options.success(data);
      },
    );
  };

  /**
	 * returns the rendered favlist block
	 *
	 * @param {Object} options
     */
  $.visitBerlinFavorites.getTeasers = function (options) {
    $.getJSON(
      $.visitBerlinFavorites._buildUrl('favorites/js/list'),
      (data) => {
        if (typeof options.success === 'function') options.success(data);
      },
    );
  };

  /**
	 * copy all or selected favorites by user from one favorite type to another
	 *
	 * @param {Object} callback with mandatory properties "fid" (integer, array if integers or keyword 'all'), "from" and "to"
	 */
  $.visitBerlinFavorites.copy = function (options) {
    $.getJSON(
      $.visitBerlinFavorites._buildUrl('favorites/js/copy'),
      {
        from: options.from,
        to: options.to,
        fid: options.fid,
      },

      // data contains the (real) number of copied favorites
      // or an error message string
      (data) => {
        if (typeof options.success === 'function') options.success(data);
      },
    );
  };

  /**
   * forward all favorites by user as email
   *
   * @param {string} options
   * @param {string} options.firstname
   * @param {string} options.lastname
   * @param {string} options.sender
   * @param {string} options.message
   * @param {string} options.newsletter
   * @param {string} options.agb
   * @param {string} options.recipient
   * @param {function} options.success
   */
  $.visitBerlinFavorites.forward = function (options) {
    $.post(
      $.visitBerlinFavorites._buildUrl('favorites/js/forward'),
      {
        recipient: options.recipient,
        firstname: options.firstname,
        lastname: options.lastname,
        sender: options.sender,
        message: options.message,
        newsletter: options.newsletter,
        agb: options.agb,

      },
      (data) => {
        if (typeof options.success === 'function') options.success(data);
      },
    );
  };

  /**
   * build ajax url
   *
   * @param {String} path local path
   * @param type
   * @return {String}
   */
  $.visitBerlinFavorites._buildUrl = function (path, type) {
    return drupalSettings.path.baseUrl + drupalSettings.path.pathPrefix + path
          + (($.visitBerlinFavorites.USER_TOKEN) ? `?token=${$.visitBerlinFavorites.USER_TOKEN}` : '')
          + (type != undefined ? `&type=${type}` : '');
  };

  $.visitBerlinFavorites._getUserToken = function () {
    return $('span[data-favorites-token]').data('favorites-token');
  };
}(jQuery));

(function ($) {
  Drupal.behaviors.mamFavorite = {
    attach() {
      // clickhandler for favorites copying
      $('a[data-fav-copy-type]').on('click', function () {
        const options = {
          from: $(this).data('fav-copy-from'),
          to: $(this).data('fav-copy-to'),
        };

        switch ($(this).data('fav-copy-type')) {
          case 'all':
            options.fid = 'all';
            break;

          case 'select':
            options.fid = [];
            $('input[data-fav-copy-select]').filter(':checked').each(function () {
              options.fid.push($(this).data('fav-copy-select'));
            });
            break;
          default:
            break;
        }

        $.visitBerlinFavorites.copy(options);
        return false;
      });

      // forward favorites

      const $formFavForward = $('.form-fav-forward');
      const { lang } = document.documentElement;

      $formFavForward.on('submit', () => {
        $.visitBerlinFavorites.forward({
          firstname: $('#fav-forward-first-name').val(),
          lastname: $('#fav-forward-last-name').val(),
          sender: $('#fav-forward-mail-sender').val(),
          recipient: $('#fav-forward-mail-recipient').val(),
          message: $('#fav-forward-message').val(),
          newsletter: $('#fav-forward-newsletter').is(':checked'),
          agb: $('#fav-forward-agb').is(':checked'),
          success(msg) {
            if (msg === true) {
              let outputText;
              if (lang === 'en') {
                outputText = 'Your notes have been successfully forwarded.';
              } else {
                outputText = 'Ihr Merkzettel wurde erfolgreich weitergeleitet.';
              }

              // show message
              Drupal.behaviors.message.show(outputText);
            } else {
              $('.fav-forward-error').foundation('open');
              throw new Error(msg);
            }
          },
        });

        $formFavForward.foundation('close');

        return false;
      });

      // append fav links to main menu
      // todo: nodeIDs in config

      // const menus = [
      //   {
      //     selector: '#block-mainnavigation > ul.menu', // desktop menu
      //     badgeClass: 'alert',
      //   },
      //   {
      //     selector: '#block-hauptmenuenglisch > ul.menu', // desktop menu
      //     badgeClass: 'alert',
      //   },
      //   {
      //     selector: '.vb-header-nav-mobile .vb-mobile-favourites', // mobile menu
      //     badgeClass: 'alert',
      //   },
      // ];

      Drupal.behaviors.mamFavorite.favoriteUpdateCounter();
      // Drupal.behaviors.mamFavorite._favoriteUpdateList();
      Drupal.behaviors.mamFavorite.favoriteAdd();
      Drupal.behaviors.mamFavorite.favoriteCopy();
      Drupal.behaviors.mamFavorite.favoriteRemove();
      Drupal.behaviors.mamFavorite.favoriteUpdateMailTo();
      Drupal.behaviors.mamFavorite.favoriteActiveMenuLink();
    },

    favoriteUpdateCounter() {
      // Menu: count by fav type
      $.visitBerlinFavorites.getCount({
        success(data) {
          $('[data-fav-count-type="anfragen"]').html(data.anfragen);
          $('[data-fav-count-type="merkzettel"]').html(data.merkzettel);
          $('[data-fav-count-type="mam-selection"]').html(data['mam-selection']);
          const $enquiryBadge = $('[data-fav-count-type="anfragen"]');
          // eslint-disable-next-line max-len
          const enquiryBadgeCount = $enquiryBadge.length ? parseInt($enquiryBadge.html().trim(), 10) : 0;
          const $notesBadge = $('[data-fav-count-type="merkzettel"]');
          // eslint-disable-next-line max-len
          const notesBadgeCount = $enquiryBadge.length ? parseInt($notesBadge.html().trim(), 10) : 0;

          $($enquiryBadge, $notesBadge).removeClass('pulse');

          if (!Number.isNaN(enquiryBadgeCount) && enquiryBadgeCount < parseInt(data.anfragen, 10)) {
            // add pulse animation class if number is increasing
            $enquiryBadge.addClass('pulse');
          }

          if (!Number.isNaN(notesBadgeCount) && notesBadgeCount < parseInt(data.merkzettel, 10)) {
            // add pulse animation class if number is increasing
            $notesBadge.addClass('pulse');
          }

          $enquiryBadge.html(data.anfragen);
          $notesBadge.html(data.merkzettel);
        },
      });

      // Details Page: count displayed favs by node type
      $('[data-fav-count-node-type]').each(function () {
        const $this = $(this);
        const nodeTypes = $this.attr('data-fav-count-node-type').split(' ');

        let nodeTypesSelector = '';
        // eslint-disable-next-line no-plusplus
        for (let i = nodeTypes.length; i >= 0; i--) {
          nodeTypesSelector += `[data-fav-node-type="${nodeTypes[i]}"],`;
        }
        nodeTypesSelector = nodeTypesSelector.slice(0, -1);

        $this.html($(nodeTypesSelector).length);
      });
    },

    favoriteAdd() {
      $(document).on('click', '[data-fav-add]', function () {
        const $this = $(this);
        const $msg = $('#vb-message');
        const nid = $this.attr('data-fav-add');
        const type = $this.attr('data-fav-type');
        const title = $this.attr('data-fav-title');
        const lang = $('html').attr('lang');
        let outputText;

        // hide message
        $msg.dequeue().removeClass('active');

        $.visitBerlinFavorites.favoriteExists({
          nid,
          success(data) {
            // favorite does not already exist
            if (data[0].data === false) {
              // output text
              outputText = `<strong>${title}</strong>`;

              switch (type) {
                case 'merkzettel':
                  if (lang === 'en') {
                    outputText += ' successfully added to your notes.';
                  } else {
                    outputText += ' wurde erfolgreich zum Merkzettel hinzugefügt.';
                  }
                  break;
                case 'anfrage':
                  if (lang === 'en') {
                    outputText += ' successfully added to your enquiry.';
                  } else {
                    outputText += ' wurde erfolgreich zur Anfrage hinzugefügt.';
                  }
                  break;
                case 'mam-selection':
                  if (lang === 'en') {
                    outputText += ' successfully added to your kit.';
                  } else {
                    outputText += ' wurde erfolgreich zum Kit hinzugefügt.';
                  }
                  break;
                default:
                  break;
              }

              $.visitBerlinFavorites.addFavorite({
                nid,
                type,
                success() {
                  Drupal.behaviors.mamFavorite.favoriteUpdateCounter();

                  // show message
                  Drupal.behaviors.message.show(outputText);
                },
              });
            } else {
              // output text
              outputText = `<strong>${title}</strong>`;

              switch (type) {
                case 'merkzettel':
                  if (lang === 'en') {
                    outputText += ' has already been added to your notes.';
                  } else {
                    outputText += ' wurde bereits zum Merkzettel hinzugefügt.';
                  }
                  break;
                case 'anfrage':
                  if (lang === 'en') {
                    outputText += ' has already been added to your enquiry.';
                  } else {
                    outputText += ' wurde bereits zur Anfrage hinzugefügt.';
                  }
                  break;
                case 'mam-selection':
                  if (lang === 'en') {
                    outputText += ' has already been added to your kit.';
                  } else {
                    outputText += ' wurde bereits zum Kit hinzugefügt.';
                  }
                  break;
                default:
                  break;
              }

              // show message
              Drupal.behaviors.message.show(outputText);
            }
          },
        });

        return false;
      });
    },

    favoriteCopy() {
      $(document).on('click', '[data-fav-copy-to]', function () {
        const $this = $(this);
        const $msg = $('#vb-message');
        const copyTarget = $this.attr('data-fav-copy-to');
        const copyType = $this.attr('data-fav-copy-type');
        const copyFrom = (copyTarget === 'merkzettel') ? 'anfrage' : 'merkzettel';
        const lang = $('html').attr('lang');
        let selectedFids;
        let outputText;

        // hide message
        $msg.dequeue().removeClass('active');

        if (copyType === 'selected') {
          selectedFids = [];
          $('[data-fav-copy-fid]:checked').each(function () {
            selectedFids.push($(this).attr('data-fav-copy-fid'));
          });

          if (selectedFids.length === 0) {
            // nothing selected
            return false;
          }
        } else {
          selectedFids = 'all';
        }

        $.visitBerlinFavorites.copy({
          from: copyFrom,
          to: copyTarget,
          fid: selectedFids,
          success() {
            Drupal.behaviors.mamFavorite.favoriteUpdateCounter();

            // output text
            if (copyTarget === 'merkzettel') {
              if (lang === 'en') {
                outputText = 'Selection successfully added to your notes.';
              } else {
                outputText = 'Die Auswahl wurde erfolgreich zum Merkzettel hinzugefügt.';
              }
            } else if (copyTarget === 'anfrage') {
              if (lang === 'en') {
                outputText = 'Selection successfully added to your enquiry.';
              } else {
                outputText = 'Die Auswahl wurde erfolgreich zur Anfrage hinzugefügt.';
              }
            }

            // show message
            Drupal.behaviors.message.show(outputText);
          },
        });

        return false;
      });
    },

    favoriteRemove() {
      $(document).on('click', '[data-fav-remove]', function () {
        const $this = $(this);
        const fid = $this.attr('data-fav-remove');
        if (fid === 'all') {
          // todo: are u sure?
          // delete all
          $.visitBerlinFavorites.removeAllFavorites({
            type: $this.attr('data-fav-type'),
            success() {
              $('[data-fav-id]').remove();
              Drupal.behaviors.mamFavorite.favoriteUpdateCounter();
              // Drupal.behaviors.mamFavorite._favoriteUpdateList();
              Drupal.behaviors.mamFavorite.favoriteUpdateMailTo();
              Drupal.behaviors.mamFavorite.favoriteNoEntryMessage();
            },
          });
        } else {
          // delete mam asset
          if ($(this).hasClass('vb-fav-remove-mam')) {
            $.visitBerlinFavorites.removeMamFavorite({
              fid,
              success() {
                $(`[data-fav-id="${fid}"]`).remove();

                Drupal.behaviors.mamFavorite.favoriteUpdateCounter();
                // Drupal.behaviors.mamFavorite._favoriteUpdateList();
              },
            });
            return false;
          }

          // todo: are u sure?
          // delete by id
          $.visitBerlinFavorites.removeFavorite({
            fid,
            success(data) {
              $(`[data-fav-id="${data.fid}"]`).remove();
              $.visitBerlin.favoriteUpdateCounter();
              // $.visitBerlin._favoriteUpdateList();
              $.visitBerlin.favoriteUpdateMailTo();
            },
          });
        }
        return false;
      });
    },

    favoriteUpdateMailTo() {
      $('[data-fav-mailto]').each(function () {
        const $this = $(this);
        const $links = $('[data-fav-url]');
        const urls = [];

        if ($links.length === 0) {
          $this.hide();
          return false;
        }

        $links.map(function () {
          urls.push($(this).attr('data-fav-url'));
          return null;
        });

        const mailTo = `${$this.attr('data-fav-mailto')}&body=${urls.join(', ')}`;
        $this.attr('href', `mailto:?${mailTo}`);

        return null;
      });
    },

    favoriteActiveMenuLink() {
      if ($('[data-menu-link-active]').length) {
        $('.vb-header-nav-main')
          .find(`a[data-drupal-link-system-path="${$('[data-menu-link-active]').data('menu-link-active')}"]`)
          .addClass('is-active')
          .parent('li')
          .addClass('active');
      }
    },

    favoriteNoEntryMessage() {
      const $article = $('article');
      const $container = $article.find('.vb-view-container');

      // remove collection
      $container.remove();
      // add text
      $article.append(
        `<p>${
          Drupal.t('Your collection is still empty.')
        }</p>`,
      );
    },
  };
}(jQuery));

// end of mam--favorite.js
